export const recordEventToHotjar = eventName => {
  // Hotjar script is injected by GTM
  if (typeof window.hj !== "function") {
    throw Error("Hotjar script is not loaded")
  }

  window.hj("event", eventName)
}
